<script setup lang="ts">
import type { ButtonVariant } from 'bootstrap-vue-next';
import { BButton, BCard } from 'bootstrap-vue-next';
import type { RouteLocationRaw } from 'vue-router';

withDefaults(defineProps<{
  title: string;
  actionName: string;
  to?: RouteLocationRaw;
  buttonVariant?: ButtonVariant;
  disabled?: boolean;
}>(), {
  to: undefined,
  buttonVariant: 'outline-primary',
  disabled: false,
});

const emit = defineEmits<{ 'action-click': [] }>();
</script>

<template>
  <BCard
    class="overflow-hidden h-100"
    :title="title"
  >
    <slot />
    <template #footer>
      <BButton
        :variant="buttonVariant"
        :to="disabled ? undefined : to"
        :disabled="disabled"
        @click="emit('action-click')"
      >
        {{ actionName }}
      </BButton>
    </template>
  </BCard>
</template>
